<div class="now-opening sopo-popup-inner-container">
    <div class="sopo-popup-title">{{ header }}</div>
    <div class="sopo-popup-text">{{ body }}</div>
    <div class="prediction">
        @if (color === 'RED') {
            <div class="prediction-color red"> 
                <img src="assets/img/side-betting/suits/heart.webp" alt="heart" class="suit-icon left"/>
                <div class="text">RED</div>
                <img src="assets/img/side-betting/suits/diamond.webp" alt="diamond" class="suit-icon right"/>
            </div>
        } @else if (color === 'BLACK') {
            <div class="prediction-color black"> 
                <img src="assets/img/side-betting/suits/club.webp" alt="club" class="suit-icon left"/>
                <div class="text">BLACK</div>
                <img src="assets/img/side-betting/suits/spade.webp" alt="spade" class="suit-icon right"/>
            </div>
        } @else {
            <div class="no-prediction"> No Active Predictions </div>
        }
        @if (amount) {
            <div class="prediction-amount"> 
                <img [src]="currency === 'golds' ? 'assets/icon/chips/gold_chip.webp' : 'assets/img/sweep/money.webp'" alt="money" class="currency"/>
                <span class="amount">{{ amount }}</span>
            </div>
        }
    </div>
    <div class="sopo-popup-button-container">
        <div class="ion-activatable clickable" [ngClass]="notificationsDisabled ? 'sopo-popup-green-button': 'sopo-popup-yellow-button'" (click)="toggleNotifications()">
            {{ okText }}
            <ion-ripple-effect></ion-ripple-effect>
        </div>
        <div class="ion-activatable clickable" [ngClass]="color || !canPredict ? 'disabled' : 'sopo-popup-green-button'" (click)="predict()">
            PREDICT
            <ion-ripple-effect></ion-ripple-effect>
        </div>
        <div class="sopo-popup-green-button ion-activatable clickable" (click)="close()">
            {{ cancelText }}
            <ion-ripple-effect></ion-ripple-effect>
        </div>
    </div>
</div>
